import { useEffect, useState } from "react";

import { useDebounce } from "@whoosh/utilities/src/hooks";

export const useDebouncedSearch = (search: string, delay = 500) => {
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const updateDebouncedSearch = useDebounce(setDebouncedSearch, delay);

  useEffect(() => {
    if (search.length === 0) {
      updateDebouncedSearch.cancel();
      setDebouncedSearch("");
      return;
    }

    updateDebouncedSearch(search);
  }, [search, updateDebouncedSearch]);

  return debouncedSearch;
};
